// extracted by mini-css-extract-plugin
export default {"title":"Review_title__H+OAY","feedback":"Review_feedback__4Eszq","statistics":"Review_statistics__M0hmE","video":"Review_video__+2T6R","video__title":"Review_video__title__zYHeV"};